import React, { Fragment } from 'react';
import { Row, Col, Table } from 'reactstrap';

const ComboModal = ({ data }) => {
    const comboFields = Array.isArray(data.comboFields) ? data.comboFields : [];

    // Safely get EA Fees (assume all same, pick first non-null)
    const eaFees = comboFields.find(f => f?.ea_fees != null)?.ea_fees ?? null;

    return (
        <Fragment>
            <Row className="mt-4">
                <Col sm="12">
                    <Table>
                        <thead>
                            <tr>
                                <th>Label</th>
                                <th className="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {comboFields.length === 0 ? (
                                <tr>
                                    <td colSpan="2" className="text-center text-muted">
                                        No combo data available
                                    </td>
                                </tr>
                            ) : (
                                comboFields.map((field, idx) => {
                                    const label = field?.lable ?? "-";
                                    const amount = field?.amount ?? 0;
                                    return (
                                        <tr key={field?.id || idx}>
                                            <td>{label}</td>
                                            <td className="text-right pr-5">{amount}</td>
                                        </tr>
                                    );
                                })
                            )}
                            {eaFees !== null && (
                                <tr style={{ fontWeight: 'bold', background: '#DCE6F1' }}>
                                    <td>EA Fees</td>
                                    <td className="text-right pr-5">{eaFees}</td>
                                </tr>
                            )}
                            {data?.insurance_amount !== null && data?.insurance_amount !== undefined && (
                                <tr>
                                    <td>Insurance Amount</td>
                                    <td className="text-right pr-5">{data.insurance_amount}</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default ComboModal;